import { IFilters, IPaginateResponse } from "@/interfaces/Fetch";
import Opco, { OpcoForm } from "@/interfaces/Opco";
import api from "./api";

export const opcosApi = api.injectEndpoints({
  endpoints: (builds) => ({
    getOpcos: builds.query<IPaginateResponse<Opco>, IFilters>({
      query: (params) => ({
        url: "/opcos",
        params,
      }),
      providesTags: (result, _error, _arg) =>
        result
          ? [
              ...result.data.map(({ id }) => ({
                type: "Opcos" as const,
                id,
              })),
              { type: "Opcos", id: "LIST" },
            ]
          : [{ type: "Opcos", id: "LIST" }],
    }),
    storeOpco: builds.mutation<Opco, OpcoForm>({
      query: (data) => ({
        url: `/opcos`,
        method: "POST",
        body: data,
      }),
      invalidatesTags: [{ type: "Opcos", id: "LIST" }],
    }),
    deleteOpco: builds.mutation<void, string>({
      query: (id) => ({
        url: `/opcos/${id}`,
        method: "DELETE",
      }),
      invalidatesTags: [{ type: "Opcos", id: "LIST" }],
    }),
  }),
  overrideExisting: true,
});

export const {
  useDeleteOpcoMutation,
  useGetOpcosQuery,
  useStoreOpcoMutation,
  useLazyGetOpcosQuery,
} = opcosApi;
